import { Component, OnInit } from "@angular/core";

/*
 * WARNING: This component was not fully implemented
 */

@Component({
  selector: "app-user-settings",
  templateUrl: "./user-settings.component.html",
  styleUrls: ["./user-settings.component.scss"]
})
export class UserSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
